<template>
  <ExternalQueryList
      headline="Primary Menu Link Children"
      endpoint="/api/v2/primary-menu-link-children"
      :endpoint-filters="{primary_menu_link_id: primaryMenuLink.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/primary-menu-link-children/priorities"
      :get-reorder-payload="data => ({primary_menu_link_children: data})"
      @show="primaryMenuLinkChild => $router.push(getUrl(primaryMenuLinkChild))"
  >
    <template v-slot:default="{ row: primaryMenuLinkChild }">
      <td>
        <router-link :to="getUrl(primaryMenuLinkChild)">
          {{ primaryMenuLinkChild.attributes.text }}
        </router-link>
      </td>

      <td>
        {{ primaryMenuLinkChild.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/primary-menu-links/'+primaryMenuLink.id+'/children/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    },

    primaryMenuLink: {
      required: true
    },
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(primaryMenuLinkChild) {
      return '/portals/' + this.portal.id + '/content/primary-menu-links/' + this.primaryMenuLink.id + '/children/' + primaryMenuLinkChild.id + '/edit'
    }
  }
}
</script>
